export default __webpack_public_path__ + "static/media/illust_text_section2.12e2ae8e.svg";